var _circle, _path, _path2;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgIcon5(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 44,
    height: 44,
    viewBox: "0 0 44 44",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 22,
    cy: 22,
    r: 22,
    fill: "#04B776",
    fillOpacity: 0.23
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M19 23L18.2929 22.2929L19 21.5858L19.7071 22.2929L19 23ZM20 32C20 32.5523 19.5523 33 19 33C18.4477 33 18 32.5523 18 32L20 32ZM13.2929 27.2929L18.2929 22.2929L19.7071 23.7071L14.7071 28.7071L13.2929 27.2929ZM19.7071 22.2929L24.7071 27.2929L23.2929 28.7071L18.2929 23.7071L19.7071 22.2929ZM20 23L20 32L18 32L18 23L20 23Z",
    fill: "#04B776"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M25 21L24.2929 21.7071L25 22.4142L25.7071 21.7071L25 21ZM26 12C26 11.4477 25.5523 11 25 11C24.4477 11 24 11.4477 24 12L26 12ZM19.2929 16.7071L24.2929 21.7071L25.7071 20.2929L20.7071 15.2929L19.2929 16.7071ZM25.7071 21.7071L30.7071 16.7071L29.2929 15.2929L24.2929 20.2929L25.7071 21.7071ZM26 21L26 12L24 12L24 21L26 21Z",
    fill: "#04B776"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcon5);
export default __webpack_public_path__ + "static/media/icon5.cc85de7893149667fd42af85610ff6e3.svg";
export { ForwardRef as ReactComponent };